import { useState, KeyboardEvent } from "react";
import { Send } from "lucide-react";
import styles from "./CommentSection.module.scss";

interface CommentInputProps {
  onSubmit: (body: string) => Promise<void>;
  placeholder?: string;
  autoFocus?: boolean;
}

export default function CommentInput({
  onSubmit,
  placeholder = "Write a comment...",
  autoFocus = false,
}: CommentInputProps) {
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(false);

  const trimmed = body.trim();
  const isDisabled = !trimmed || loading;

  const handleSubmit = async () => {
    if (!trimmed) return;
    setLoading(true);
    try {
      await onSubmit(trimmed);
      setBody("");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (!isDisabled) {
        handleSubmit();
      }
    }
  };

  return (
    <div className={styles.commentInput}>
      <input
        type="text"
        className={styles.commentInputField}
        value={body}
        onChange={(e) => setBody(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        autoFocus={autoFocus}
        disabled={loading}
      />
      <button
        className={styles.commentInputSubmit}
        onClick={handleSubmit}
        disabled={isDisabled}
        aria-label="Send comment"
      >
        <Send size={16} />
      </button>
    </div>
  );
}
